module.exports = __webpack_public_path__ + "static/media/grip-vertical.d180dee9.svg";